import { CONCERTS_SLUGS } from '@v2/views/events/constants/concertCategories';

export const CONCERTS_ID = [54, 82, 57];

export const isConcertsPage = (
  pathname?: string | null,
  parentId?: string | null
) => {
  const segments = (pathname ?? '').toLowerCase().split('/').filter(Boolean);
  const leagueSlug =
    segments[0] === 'events'
      ? segments[1]
      : segments[0]?.replace(/-travel-packages$/, '');

  return (
    CONCERTS_SLUGS.includes(leagueSlug ?? '') ||
    CONCERTS_ID.includes(Number(parentId))
  );
};

const HIDDEN_LEAGUE_EVENT_NAME_FRAGMENT =
  '(includes tickets to all regular season home games)';

export const shouldHideLeagueEvent = (eventName?: string) =>
  eventName?.toLowerCase().includes(HIDDEN_LEAGUE_EVENT_NAME_FRAGMENT) ?? false;
